<h1 id="main-heading" class="sr-only" tabindex="-1" aria-hidden="false">Resource Routing Metrics</h1>
<div class="fix-height flex justify-end">
  <app-table-action-buttons
    [isLoading]="isLoading"
    (clearFilters)="clearFilters()"
    (fetchTableData)="fetchTableData()"
  />
</div>
<p-table
  #table
  class="block table-height-reduced-50"
  currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
  [dataKey]="dataKey"
  [totalRecords]="totalRecords"
  [scrollable]="true"
  [scrollHeight]="'flex'"
  [sortField]="'createdDate'"
  [sortOrder]="-1"
  [lazy]="true"
  [paginator]="true"
  [loading]="isLoading"
  [filterDelay]="500"
  [rowsPerPageOptions]="[5, 10, 20]"
  [value]="metrics$ | async"
  [columns]="columnConfig"
  [rowExpandMode]="'single'"
  [showCurrentPageReport]="true"
  [(rows)]="rowsPerPage"
  (onLazyLoad)="fetchTableData($event)"
  (onRowExpand)="getExpandedData($event.data)"
>
  <ng-template #header>
    <tr>
      @for (column of columnConfig; track column) {
        <th [style]="column.styles" [pSortableColumn]="column.dataKey" [pSortableColumnDisabled]="!column.isSortable">
          <div class="flex items-center">
            {{ column.name }}
            @if (column.isSortable) {
              <p-sortIcon class="p-2" [field]="column.dataKey" />
            }
          </div>
        </th>
      }
    </tr>
    <tr class="header-filter">
      @for (column of columnConfig; track column) {
        <th>
          @switch (column.filterOptions?.template) {
            @case ('text') {
              <ng-container *ngTemplateOutlet="text; context: { $implicit: column }" />
            }
            @case ('datepicker') {
              <ng-container *ngTemplateOutlet="datepicker; context: { $implicit: column }" />
            }
            @case ('dropdown') {
              <ng-container *ngTemplateOutlet="dropdown; context: { $implicit: column }" />
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #body let-item let-expanded="expanded">
    <tr [pSelectableRow]="item" [class]="{ 'row-expanded': expanded, routed: !item.isRouted }">
      @for (column of columnConfig; track column) {
        <td>
          @switch (column.dataKey) {
            @case ('expand') {
              <p-button
                type="button"
                text
                rounded
                [pRowToggler]="item"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              />
            }
            @case ('createdDate') {
              <div>{{ item[column.dataKey] | date : 'MM/dd/yyyy hh:mm:ss a' }}</div>
              <div>({{ item.routingIdentifier }})</div>
            }
            @case ('routedBy') {
              <div class="leading-normal py-2 routed-by">
                <ul>
                  @for (i of item[column.dataKey] | keyvalue : originalOrder | slice : 0 : maxRoutedLines; track i) {
                    <li>
                      <span class="label">{{ i.key }}</span>
                      <span class="text-ellipsis overflow-hidden">: {{ i.value }}</span>
                    </li>
                  }
                </ul>
                @if (item.routedByLength > 0) {
                  <p-popover #op [dt]="DarkPopover">
                    <div [innerHTML]="item.tooltip"></div>
                  </p-popover>
                  <div class="text-info cursor-pointer" (mouseenter)="op.show($event)" (mouseleave)="op.hide()">
                    + {{ item.routedByLength }} more
                  </div>
                }
              </div>
            }
            @case ('serviceNumber') {
              @if (productName === 'hh') {
                {{ 'Service Line ' + item[column.dataKey] + (item.skillCode ? ' - ' + item.skillCode : '') }}
              } @else {
                {{ item[column.dataKey] }}
              }
            }
            @default {
              {{ item[column.dataKey] }}
            }
          }
        </td>
      }
    </tr>
  </ng-template>
  <ng-template #expandedrow>
    <tr>
      <td colspan="9" class="p-4">
        <app-table-expanded-view [tabs]="tabs" [data]="queueEvaluation$ | async" />
      </td>
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="9">No records found</td>
    </tr>
  </ng-template>
</p-table>

<ng-template #text let-config>
  <p-iconfield>
    <p-inputicon class="pi pi-search" (click)="searchInput.focus()" />
    <input
      #searchInput
      class="w-full"
      pInputText
      type="text"
      placeholder="Search"
      [ngModel]="table.filters[config.dataKey]?.value"
      (input)="table.filter($event.target?.value, config.dataKey, 'contains')"
    />
  </p-iconfield>
</ng-template>

<ng-template #datepicker let-config>
  <p-date-picker
    appendTo="body"
    dateFormat="mm/dd/yy"
    placeholder="Filter"
    selectionMode="range"
    [maxDate]="maxFilterDate"
    [showIcon]="true"
    [showButtonBar]="true"
    [(ngModel)]="table[config.dataKey]"
    (ngModelChange)="filterDateField(table[config.dataKey], config.dataKey)"
  />
</ng-template>

<ng-template #dropdown let-config>
  <p-select
    placeholder="Filter"
    appendTo="body"
    [options]="routedOptions"
    [showClear]="true"
    [ngModel]="table.filters[config.dataKey]?.value"
    (onChange)="table.filter($event.value, config.dataKey, 'eq')"
  />
</ng-template>
